import { createAsyncThunk } from '@reduxjs/toolkit';
import staffProductService from './staffProductService';
import { restructureErrorMessage } from '../../helpers/errorMessage';

export const getSmeStaffProductsThunk = createAsyncThunk(
  'staff/sme/getProduct',
  async (requestData: any, thunkAPI) => {
    try {
      return await staffProductService.getSmeStaffProduct(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const createSmeStaffProductThunk = createAsyncThunk(
  'staff/sme/createProduct',
  async (requestData: any, thunkAPI) => {
    try {
      return await staffProductService.createSmeStaffProduct(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const updateSmeStaffProductThunk = createAsyncThunk(
  'staff/sme/updateProduct',
  async (requestData: any, thunkAPI) => {
    try {
      return await staffProductService.updateSmeStaffProduct(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);

export const deleteSmeStaffProductByIdThunk = createAsyncThunk(
  'staff/sme/deleteProduct',
  async (requestData: any, thunkAPI) => {
    try {
      return await staffProductService.deleteSmeStaffProductById(requestData);
    } catch (error) {
      const message = restructureErrorMessage(error);
      return thunkAPI.rejectWithValue(message);
    }
  }
);
